import React, { Component } from 'react';
import { Layout } from '$components/app';
import Cookies from 'js-cookie';
import { currentAgentSelector, currentAccountSelector } from '$selectors';
import { fetchCurrent as fetchCurrentAgent } from '$actions/agents';
import { fetchCurrent as fetchCurrentAccount } from '$actions/accounts';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router'

@connect(state => ({
  agent: currentAgentSelector(state),
  account: currentAccountSelector(state)
}), { fetchCurrentAgent, fetchCurrentAccount })
export default class AppRoute extends Component {
  componentWillMount() {
    if (Cookies.get('token')) {
      this.props.fetchCurrentAgent();
      this.props.fetchCurrentAccount();
    }
  }
  
  render() {
    if (Cookies.get('token')) {
      const { agent, account = {}, params } = this.props;

      if (typeof agent !== "undefined") {
        Cookies.set('locale', agent.locale);
        Cookies.set('agent', agent);
        return (
          <Layout agent={agent} account={account} params={params}>
            {this.props.children}
          </Layout>
        )
      } else {
        return (
          null
        )
      }
    } else {
      browserHistory.push('/login');
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/routes/app.js